import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../Services/loader-service.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-contact-us',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent {
  contactForm: FormGroup;
  openIndex: number | null = 1;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiCallService,
    private errorHandler: ErrorhandlingService,
    private toastr: ToastrService,
    private loaderService: LoaderService
  ) {
    this.contactForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      message: ['', Validators.required],
    });
  }

  onSubmit() {
    if (this.contactForm.valid) {
      this.loaderService.show();
      const formValue = this.contactForm.value;
      const payload = {
        userName: `${formValue.firstName} ${formValue.lastName}`,
        userEmail: formValue.email,
        message: formValue.message,
        contactNumber: formValue.phone,
      };

      this.apiService
        .PostCallWithoutToken(payload, 'Public/UserContactUs')
        .subscribe(
          (response) => {
            if (response.responseCode === 200) {
              this.loaderService.hide();
              this.toastr.success(response.responseMessage, 'Success');
              this.contactForm.reset();
            } else {
              this.errorHandler.handleResponseError(response);
              this.loaderService.hide();
            }
          },
          (error) => {
            this.errorHandler.handleHttpError(error);
            this.loaderService.hide();
          }
        );
    } else {
      this.toastr.warning('Please fill in all required fields.', 'Warning');
    }
  }


  toggle(index: number) {
    this.openIndex = this.openIndex === index ? null : index;
  }

faqs = [
  { index: 1, question: 'How do I start playing games on the platform?', answer: 'Simply create a free account, verify your profile, and explore our wide range of games and interactive challenges.' },
  { index: 2, question: 'Is the platform free to join?', answer: 'Yes! Signing up is completely free. You can browse games, enter community events, and play free tiers without any hidden charges.' },
  { index: 3, question: 'Can I play on mobile devices?', answer: 'Absolutely! Our platform is fully optimized for both iOS and Android browsers, so you can enjoy gaming anytime, anywhere.' },
  { index: 4, question: 'What should I do if I face technical issues?', answer: 'If you run into any issues, simply contact our support team via the Contact Us form, and we’ll assist you right away.' },
  { index: 5, question: 'How do I earn rewards on the platform?', answer: 'You can earn tokens and points by participating in daily challenges, unlocking milestones, and topping the community leaderboards.' }
];
}
